<div class="modal--wrapper">
  <ark-post-publish
    (cancel)="cancel()"
    (publish)="publish($event)"
  ></ark-post-publish>
</div>
